module.exports = __webpack_public_path__ + "img/003.22eba1c0.png";